<template>
  <div v-if="!isPageLoading" class="all-courses">
    <template v-if="selectionType == 'new'">
      <div
        v-if="newCourses && newCourses.length"
        class="all-courses__background"
        :style="
          `background-image: url(${newCourses[0].images.main_image_url}), linear-gradient(#151515, #262626);`
        "
      >
        <div class="all-courses__overlay"></div>
      </div>
      <New :courses="newCourses" :isFreeTrialUser="isFreeTrialUser" />
    </template>
    <template v-else>
      <Tagged
        :algoliaKeys="algoliaKeys"
        :selectionType="selectionType"
        :isFreeTrialUser="isFreeTrialUser"
      />
    </template>
  </div>
  <div v-else class="all-courses__loader-wrapper">
    <LoadingSpinner />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { createAlgoliaIndices } from '@/utils'
import LoadingSpinner from '@/components/loaders/LoadingSpinner.vue'
import New from '@/components/all-courses/New.vue'
import Tagged from '@/components/all-courses/Tagged.vue'

export default {
  name: 'AllCourses',
  components: {
    LoadingSpinner,
    New,
    Tagged,
  },
  metaInfo() {
    const { selectionType } = this
    return {
      title:
        selectionType && selectionType.length
          ? `INE - ${selectionType[0].toUpperCase() +
              selectionType.substring(1)} Courses`
          : 'INE - Courses',
    }
  },
  data: () => {
    return {
      courses: {
        NewCourses: [],
      },
    }
  },
  computed: {
    ...mapState({
      isPageLoading: state => state.app.isPageLoading,
      algoliaKeys: state => state.search.algoliaKeys,
    }),
    ...mapGetters({
      isFreeTrialUser: 'auth/isFreeTrialUser',
    }),
    selectionType() {
      const { name } = this.$route.params
      return name
    },
    newCourses() {
      const courses = this.courses.NewCourses
      return courses.sort((a, b) => b.published_date - a.published_date)
    },
  },
  methods: {
    handleResults(index, { hits }) {
      this.courses[index] = hits
    },
    createAlgoliaSearchInstance() {
      const {
        algoliaKeys: { appKey, appId, coursesIndex: courses },
      } = this
      const newCourses = {
        keys: {
          appId,
          appKey,
        },
        contexts: [
          {
            name: 'NewCourses',
            index: courses,
            facets: ['status'],
          },
        ],
        resultsHandler: this.handleResults,
      }
      createAlgoliaIndices(newCourses, { facet: 'status', value: 'published' })
    },
    async queryData() {
      this.$store.dispatch('app/setIsPageLoading', true)
      if (this.selectionType === 'new') {
        this.createAlgoliaSearchInstance()
      }
      this.$store.dispatch('app/setIsPageLoading', false)
    },
  },
  created() {
    this.queryData()
  },
  watch: {
    $route(to, from) {
      if (to.params.name !== from.params.name) {
        this.queryData()
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.all-courses {
  position: relative;
  &__background {
    min-height: 100vh;
    width: 100%;
    position: absolute;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 0;
  }
  &__overlay {
    position: relative;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0.7),
      var(--dark-gray),
      var(--dark-gray)
    );
    z-index: 0;
    min-height: 100vh;
    width: 100%;
  }
}
</style>
